import 'css-chunksrc/client/scenes/workloads/wbsHeader/detailsViewSelector/styles.scss';export default {
  "detailsViewSelector": "_detailsViewSelector_1fbq5_1",
  "toggleButton": "_toggleButton_1fbq5_13",
  "pressed": "_pressed_1fbq5_28"
};